import React from 'react';

function Tutorial() {
  return <div>Tutorial page</div>;
}

export default Tutorial;
